module.exports = __webpack_public_path__ + "img/pigai-visaul.e8bb89a6.png";